<form [formGroup]="form">
  <div class="gap-lg flex flex-col">
    @for (form of indicesForm.controls; track $index; let idx = $index) {
      <app-form-item-indice [form]="form" [idx]="idx + 1" />
    }
    @if (estCreation()) {
      <app-button-add-new (click)="addIndice()" label="Ajouter un indice" />
    }
  </div>
</form>
